import { fromJS } from 'immutable';
import actions from '../constants';

const initialState = fromJS({});

const update = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_FINISH:
      return fromJS(action.payload);
    case actions.GET_ERROR:
      return fromJS({});
    default:
      return state;
  }
};

export default update;



// WEBPACK FOOTER //
// ./src/modules/organizations/reducers/entities.js